import React from "react";
import { UseFormRegister } from "react-hook-form";
import { filterWeight } from "components/form-fields/weight-field/weightFieldSchema";

interface WeightFieldProps {
    register: ReturnType<UseFormRegister<any>>;
    error?: string;
    id?: string;
}

/**
 * Weight input field in pounds
 */
const WeightField = ({ register, error, id }: WeightFieldProps) => {
    const handleWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const filtered = filterWeight(e.target.value);
        if (filtered !== e.target.value) {
            e.target.value = filtered;
        }
        register.onChange(e);
    };

    return (
        <div className="form-control">
            <label className="label" htmlFor={id}>
                <span className="text-base-content">Weight</span>
            </label>
            <div className="relative w-[120px] h-9">
                <input
                    {...register}
                    id={id}
                    type="text"
                    placeholder="150"
                    className={`input input-bordered bg-base-100 text-sm w-[120px] h-9 py-0 pr-[50px] ${
                        error ? "input-error" : ""
                    }`}
                    maxLength={3}
                    onChange={handleWeightChange}
                />
                <span className="absolute top-1/2 transform -translate-y-1/2 left-[45px] text-base-content opacity-60 pointer-events-none text-sm">
                    lbs
                </span>
            </div>
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </div>
    );
};

export default WeightField;
